import React, { useMemo } from 'react'
import { useTranslation } from "react-i18next";
import InvoiceLogs from './InvoiceLogs';
import OpenBankingLogs from './OpenBankingLogs';
import { openBankingVisibility } from '../OpenBanking/OpenBankingUtils';
import { useAppContext } from '../../AppContext';
import SettingsTabs from '../Settings/SettingsTabs';

const Logs = () => {
    const { t } = useTranslation("translations");
    const { company:[fullCompany],user:[user] } = useAppContext()

    const visibility= useMemo(()=>openBankingVisibility(fullCompany,user),[fullCompany,user])

    const tabs = [
        { id: 'invoice', label: t("navbar.logs"), content: <InvoiceLogs visibility={visibility} /> },
        visibility.paymentOrder && { id: 'openBanking', label: t("openBankingLogs.paymentLogs"), content: <OpenBankingLogs /> },
    ];

    return (
        <SettingsTabs
            variant="card"
            tabs={tabs}
        />
    )
}

export default Logs
